import { Component, Input } from '@angular/core';

import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.less'],
  host: {
    '[class]': 'variant',
  },
})
export class TableComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'wide',
      'zebra-horizontal',
      'zebra-vertical',
      'zebra-odd-even',
      'plain-rows',
      'clickable-rows',
      'td-without-border',
      'heavy-thead',
      'outline',
      'raised',
      'dark-header-bordered',
    ],
  ];
  @ComponentVariant(TableComponent.VARIANTS)
  @Input()
  public variant: string;
}
